import { computed, defineComponent, useContext, useCssModule } from '@nuxtjs/composition-api';
import { useModal } from '~/composables';
export default defineComponent({
    name: 'EmailSubscription',
    props: {
        type: {
            default: 'default',
            type: String,
            validator(value) {
                return ['adfox', 'default', 'waterfall'].includes(value);
            },
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const context = useContext();
        const modal = useModal();
        const buttonSize = computed(() => {
            if (props.type === 'waterfall') {
                if (context.$viewport.isLessThan('tablet')) {
                    return 'medium';
                }
                return 'small';
            }
            if (context.$viewport.isLessThan('tablet')) {
                return 'big';
            }
            return 'medium';
        });
        function handleClick() {
            modal.open('emailSubscriptionModal', {
                componentAttrs: {
                    type: props.type,
                },
            });
        }
        return {
            buttonSize,
            css,
            handleClick,
            modal,
        };
    },
});
